var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlay6 = function SvgIconPlay6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "m36.508 38.768-7.531 4.268V25.965l7.531 4.268 7.531 4.267-7.531 4.268zM34.5 0C15.446 0 0 15.447 0 34.5 0 53.554 15.446 69 34.5 69 53.553 69 69 53.554 69 34.5 69 15.447 53.553 0 34.5 0z"
  })));
};
export default SvgIconPlay6;